import React from 'react';
import SEOHead from '../seo/SEOHead';
import PageHeader from '../components/PageHeader';

const Contact = () => {
  return (
    <>
      <SEOHead path="/contact" />
      <PageHeader title="Contact Us" breadcrumb="Contact" />

      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="overline">Get in Touch</span>
            <h2>We'd Love to Hear From You</h2>
            <p>Whether you have questions about our ministries, want to volunteer, or wish to support our mission, we're here for you.</p>
          </div>

          <div className="contact-cards fade-in">
            <div className="contact-card">
              <div className="icon">📞</div>
              <h3>Call Us in the US</h3>
              <p>Talk with Samvel Minasyan</p>
              <a href="tel:+15596688807">+1 (559) 668-8807</a>
            </div>

            <div className="contact-card">
              <div className="icon">📞</div>
              <h3>Call Us in Armenia</h3>
              <p>Talk with Gagik Mkrtchyan</p>
              <a href="tel:+37455677888">+374 55 677888</a>
            </div>

            <div className="contact-card">
              <div className="icon">✉️</div>
              <h3>Email Us</h3>
              <p>Send us a message anytime</p>
              <a href="mailto:contact@teenchallengearmenia.org">contact@teenchallengearmenia.org</a>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '48px' }}>
            <div className="navbar-socials" style={{ justifyContent: 'center', gap: '24px' }}>
              <a href="https://www.facebook.com/TeenChallengeArmenia/" target="_blank" rel="noopener noreferrer" style={{ fontSize: '15px', fontWeight: 600, color: 'var(--navy)' }}>Facebook</a>
              <a href="https://www.youtube.com/@teenchallengearmenia852" target="_blank" rel="noopener noreferrer" style={{ fontSize: '15px', fontWeight: 600, color: 'var(--navy)' }}>YouTube</a>
              <a href="https://www.instagram.com/teenchallengearmenia/" target="_blank" rel="noopener noreferrer" style={{ fontSize: '15px', fontWeight: 600, color: 'var(--navy)' }}>Instagram</a>
              <a href="https://www.linkedin.com/company/teenchallengearmenia" target="_blank" rel="noopener noreferrer" style={{ fontSize: '15px', fontWeight: 600, color: 'var(--navy)' }}>LinkedIn</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
